var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-list',_vm._l((_vm.bosses),function(boss,index){return _c('v-list-item',{key:index,on:{"click":function($event){return _vm.pick(boss)}}},[_c('v-list-item-title',[_vm._v(_vm._s(boss.name))])],1)}),1)}
var staticRenderFns = []

export { render, staticRenderFns }